import { render, staticRenderFns } from "./InsBanner.vue?vue&type=template&id=f4e89f4a&scoped=true"
import script from "./InsBanner.vue?vue&type=script&lang=ts"
export * from "./InsBanner.vue?vue&type=script&lang=ts"
import style0 from "./InsBanner.vue?vue&type=style&index=0&id=f4e89f4a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e89f4a",
  null
  
)

export default component.exports